"use client";
import { track } from "./analytics";

// Thin wrapper kept for existing call sites; now supports event properties.
export const handleButtonTracking = async (
  description: string,
  properties?: Record<string, unknown>,
) => {
  track(description, properties);
};
